import {Heap} from './heap';

class Analytics {
  static initialize() {
    Heap.initialize();
  }

  static identify(id: string) {
    Heap.identify(id);
  }

  static addUserProperties(data: Record<string, string | number>) {
    Heap.addUserProperties(data);
  }

  static addEventProperties(data: Record<string, string | number>) {
    Heap.addEventProperties(data);
  }

  static track(
    event: string,
    data?: Record<string, string | number | boolean | undefined | null>,
  ) {
    Heap.track(event, data);
  }
}

export {Analytics};
